import { cloneDeep as _cloneDeep } from 'lodash';

export function updateTemplateForBackendRangeType(template) {
    // Convert frontend convenience types to backend types
    if (template.trigger.range?.type === 'ABOVE' || template.trigger.range?.type === 'BELOW') {
        template.trigger.range.type = 'OUTSIDE';
    }
}

export function updateCountTemplateForBackend(templateData) {
    // Convert field names for counting back to the expected API names (matching project rules)
    if (templateData.trigger?.triggerCount) {
        if (templateData.trigger.field === 'proximityCount') {
            templateData.trigger.field = 'objectPresent';
        }
        if (templateData.trigger.field === 'touchCount') {
            templateData.trigger.field = 'touch';
        }
        if (templateData.trigger.field === 'contactCount') {
            templateData.trigger.field = 'contact';
        }
    }
}

export function updateScheduleTimeSlots(template) {
    // Convert string format back to time objects before saving template
    // Times may already be objects (from API) or strings (from UI editing)
    template.schedule?.slots?.map(slot => { // eslint-disable-line
        slot?.times.map(time => { // eslint-disable-line
            if (typeof time.start === 'string') {
                const start = time.start.split(',')
                time.start = {
                    hour: Number(start[0]),
                    minute: Number(start[1]),
                }
            }
            if (typeof time.end === 'string') {
                const end = time.end.split(',')
                time.end = {
                    hour: Number(end[0]),
                    minute: Number(end[1]),
                }
            }
        });
    });
}

/**
 * Prepares a template for saving to the API.
 * Converts frontend format (scope, deviceMode) to API format (projectLabels, deviceLabels).
 * @param {Object} template - The template in frontend format (will be deep-cloned)
 * @returns {Object} Template ready for API PUT
 */
export function prepareTemplateForSave(template) {
    const templateData = _cloneDeep(template);

    // Apply backend conversions (matching project rules)
    updateTemplateForBackendRangeType(templateData);

    // Convert field names for counting back to the expected API names
    updateCountTemplateForBackend(templateData);

    // Convert schedule time slots from string format to object format
    if (templateData.schedule) {
        updateScheduleTimeSlots(templateData);
    }

    // Convert scope to projectLabels format for API
    if (templateData.scope.type === 'ALL_PROJECTS') {
        // For "All projects", API expects empty object
        templateData.projectLabels = {};
    } else if (templateData.scope.type === 'PROJECT_LABELS') {
        // Keep projectLabels as object format (API expects object, not array)
        templateData.projectLabels = templateData.scope.labels || {};
    }

    // Remove the frontend scope object - API doesn't expect it
    delete templateData.scope;

    // Convert deviceLabels format for API (no deviceMode property on API)
    if (templateData.deviceMode === 'ALL') {
        // For "All devices", API expects an empty object
        templateData.deviceLabels = {};
    } else if (templateData.deviceMode === 'LABELS') {
        // For device labels mode, keep as object format (API expects object, not array)
        if (!templateData.deviceLabels || typeof templateData.deviceLabels !== 'object') {
            templateData.deviceLabels = {};
        }
    }

    // Remove the frontend deviceMode property - API doesn't expect it
    delete templateData.deviceMode;

    // Convert escalationTemplateId to escalationPath for API
    if (templateData.escalationTemplateId) {
        templateData.escalationPath = templateData.escalationTemplateId;
    }
    delete templateData.escalationTemplateId;

    return templateData;
}
